import type { TCSearcherTimelineItemDocument } from 'src/api/generated';
import { sortByCreatedAtDesc } from 'src/modules/shared/utils/sort/created-at-sort.util';

/**
 * Merges overlapping timeline results without replacing newer resource revisions.
 * Equal revisions keep the first already-reconciled snapshot; valid revisions
 * take precedence over invalid dates. Canonical HTTP correction remains owned by
 * the existing page reconciliation, not inferred from pagination order.
 * @param items - Reconciled page items in their existing page order.
 * @returns Unique resources ordered by creation time, without mutating inputs.
 */
export const mergeTimelineItems = (
  items: readonly TCSearcherTimelineItemDocument[]
): TCSearcherTimelineItemDocument[] => {
  const byIdentity = new Map<string, TCSearcherTimelineItemDocument>();
  for (const item of items) {
    const key = `${item.modelType}:${item.id}`;
    const current = byIdentity.get(key);
    const incomingRevision = Date.parse(item.updatedAt);
    const currentRevision = current ? Date.parse(current.updatedAt) : NaN;
    if (
      !current ||
      (Number.isFinite(incomingRevision) &&
        (!Number.isFinite(currentRevision) ||
          incomingRevision > currentRevision))
    ) {
      byIdentity.set(key, item);
    }
  }
  return sortByCreatedAtDesc([...byIdentity.values()]);
};
